import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'
import type { Component } from 'vue'
import { computed, markRaw, ref } from 'vue'

type ModalEntry = {
  id: string
  component: Component
  data: unknown | null
}

export const useModalsStore = defineStore('modals', () => {
  const modals = ref<ModalEntry[]>([])

  const currentModalId = computed<string | null>(() => modals.value[modals.value.length -1]?.id ?? null)

  const openModal = (component: Component, modalData?: unknown): string => {
    const id = uuidv4()
    modals.value.push({
      id,
      component: markRaw(component),
      data: modalData ?? null
    })
    return id
  }

  const closeModal = (): void => {
    modals.value.pop()
  }

  return {
    modals,
    currentModalId,
    openModal,
    closeModal
  }
})
